import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShipmentObj } from '../../models/models';

@Component({
  selector: 'app-lab-shipment-modal',
  templateUrl: './lab-shipment-modal.component.html',
  styleUrls: ['./lab-shipment-modal.component.css']
})
export class LabShipmentModalComponent implements OnInit {

  @Input() selectedShipment:ShipmentObj;
  @Output() exportPdfEvent = new EventEmitter<boolean>();
  @Output() downloadCsvEvent = new EventEmitter<boolean>();
  constructor() {
    this.selectedShipment = this.resetSelectedShipment();
 }

  resetSelectedShipment=():ShipmentObj=>{
    const shipment:ShipmentObj = {
      shipmentId:'',
      status:'',
      flag:false,
      filterFlag:true,
      dateOfCreation:''
    }
    return shipment;
  }

  ngOnInit(): void {
  }

  exportShipmentPDf(){
    this.exportPdfEvent.emit(true);
  }

  downloadCsv(){
    this.downloadCsvEvent.emit(true);
  }
}
